<template>
  <div :class="validationContainerClass">
    <v-validate
      :rules="rules"
      :vid="name"
      v-slot="{ errors, classes }"
      :name="label"
    >
      <div class="form-group">
        <label :for="id"
          >{{ label }}
          <div v-if="isRequired" class="is-required">
            <i class="fas fa-star-of-life"></i></div
        ></label>
        <date-picker
          :id="inputID"
          :name="name"
          :ref="name"
          :type="type"
          :placeholder="placeHolder"
          v-model="content"
          @input="handleInput(content)"
          :clearable="true"
          :auto-submit="true"
          :editable="true"
          :format="format"
          :display-format="displayFormat"
          :locale="locale"
          :locale-config="datePickerLocalConfig"
          :day-change-shortcut="true"
          :color="color"
          :disabled="disabled"
          :inputClass="`${inputClass} ${classes.invalid ? 'is-invalid' : ''}`"
        />
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </v-validate>
  </div>
</template>
<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import InputCommons from "./InputCommons.vue";
export default {
  extends: InputCommons,
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    locale: {
      type: String,
      default: "fa,en",
    },
    color: {
      type: String,
      default: "#1ab394",
    },
    format: {
      type: String,
      default: "YYYY-MM-DD",
    },
    displayFormat: {
      type: String,
      default: "jYYYY/jMM/jDD",
    },
  },
  computed: {
    datePickerLocalConfig() {
      if ((this.type = "datetime"))
        return {
          fa: {
            displayFormat: "jYYYY/jMM/jDD HH:mm:ss",
            lang: { label: "شمسی" },
          },
          en: {
            displayFormat: "YYYY/MM/DD HH:mm:ss",
            lang: { label: "Gregorian" },
          },
        };
      return {
        fa: {
          displayFormat: this.displayFormat,
          lang: { label: "شمسی" },
        },
        en: {
          displayFormat: this.format,
          lang: { label: "Gregorian" },
        },
      };
    },
  },
};
</script>
<style scoped>
.invalid-feedback {
  display: inline-block !important;
}
</style>
<style>
.vpd-input-group input {
  width: 100%;
}
</style>
